export const API_PATH = "/api/web/landing-page/";
// export const CATEGORY_API_PATH =
//   "https://fuji.trodly.com/api/web/landing-page/get-category-list.php?locationId=";
export const ROOT_PATH = "/";
export const SEARCH_API_PATH = ROOT_PATH + "ajax/vendors/activity/suggestLocation.php?term=";
export const SEARCH_WHOLE_SITE = ROOT_PATH + "ajax/suggestion.php";

export const LOCATION = "LOCATION";
export const CATEGORY = "CATEGORY";
export const PRICE = "PRICE";
export const DATE = "DATE";
export const ORDER = "ORDER";
export const SORT_BY = "SORT_BY";

export const PAGE_LOADER = "PAGE_LOADER";
export const CONTENT_LOADER = "CONTENT_LOADER";
export const SEARCH_LOADING = "SEARCH_LOADING";
export const SEARCH_RESULT = "SEARCH_RESULT";
export const LOCATION_SEARCH_RESULT = "LOCATION_SEARCH_RESULT";
export const SELECTED_CATEGORY = "SELECTED_CATEGORY";
export const USER_DETAILS = "USER_DETAILS";
export const DESTINATIONS = "DESTINATIONS";
export const CART_DETAILS = "CART_DETAILS";
export const CURRENCY_DETAILS = "CURRENCY_DETAILS";

export const LOAD_ACTIVITY = "LOAD_ACTIVITY";
export const ADD_ACTIVITY = "ADD_ACTIVITY";
export const QUERY_STRING = "QUERY_STRING";
export const OFFSET_INCREMENT = "OFFSET_INCREMENT";
export const RESET_OFFSET = "RESET_OFFSET";

export const QUERY_STRING_LOCATION = "QUERY_STRING_LOCATION";
export const QUERY_STRING_PRICE = "QUERY_STRING_PRICE";
export const QUERY_STRING_DATE = "QUERY_STRING_DATE";
export const QUERY_STRING_CATEGORY = "QUERY_STRING_CATEGORY";
export const QUERY_STRING_SORT = "QUERY_STRING_SORT";
export const QUERY_STRING_DURATION = "QUERY_STRING_DURATION";
export const QUERY_STRING_TOUR_TYPE = "QUERY_STRING_TOUR_TYPE";
//LMS
export const LMS_CURRENT_MODAL = "LMS_CURRENT_MODAL";
export const LMS_ACTIVITY_DETAILS = "LMS_ACTIVITY_DETAILS";
export const LMS_QUERY_DETAILS = "LMS_QUERY_DETAILS";
export const LMS_MEMBER_DETAILS = "LMS_MEMBER_DETAILS";
export const LMS_USER_DETAILS = "LMS_USER_DETAILS";
export const LMS_LOADING = "LMS_LOADING";
export const LMS_LOAD_LOCATIONS = "LMS_LOAD_LOCATIONS";
export const LMS_SHOW_SEARCH_RESULT = "LMS_SHOW_SEARCH_RESULT";
export const LMS_SET_OTP = "LMS_SET_OTP";
export const LMS_LIST_CATEGORIES = "LMS_LIST_CATEGORIES";
export const LMS_USER_DATA = "LMS_USER_DATA";
export const LMS_API_PATH = "/api/web/vdev/";

// export const API_PATH = "https://fuji.trodly.com/api/web/vdev/";

export const LMS_ROOT = "/";
export const LMS_MY_ENQUIRIES = "/my-profile/enquiries";
